import {useContext} from 'react'
import {FloatContainerContext} from '../../../helpers/context'
import PropTypes from 'prop-types'

const CalendarItem = ({content, isActive, isDisabled, onClick}) => {
  const {setActive} = useContext(FloatContainerContext)

  const clickFunction = e => {
    e.preventDefault()
    onClick()
    setActive(false)
  }

  return (
    <button
      onClick={e => clickFunction(e)}
      className={`calendar-item ${isActive && 'is-active'}`}
      disabled={isDisabled}
    >
      {content}
    </button>
  )
}

CalendarItem.propTypes = {
  onClick: PropTypes.func,
}

CalendarItem.defaultProps = {
  onClick: () => {},
}

export default CalendarItem
